import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Satellite, User, Lock } from 'lucide-react'
import api from '../api'
import { setAuthData, nextAman } from '../auth'
import { Button, Alert, Label } from '../components/ui'
import useBranding from '../useBranding'

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const businessName = useBranding()
  useEffect(() => { document.title = `${businessName} — Login` }, [businessName])

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true); setError('')
    try {
      const res = await api.post('/auth/login', form)
      setAuthData(res.data)
      // Teknisi tidak punya akses Dashboard (data sekolah/perusahaan) -- arahkan ke halaman
      // pertama yg memang bisa mereka lihat (lihat AdminRoute/Layout.jsx menu roles).
      navigate(nextAman(params.get('next')) || (res.data.role === 'admin' ? '/dashboard' : '/tiket-gangguan'))
    } catch (err) {
      setError(err.response?.data?.message || 'Login gagal')
    } finally { setLoading(false) }
  }

  const inputWrap = { position: 'relative' }
  const inputIcon = { position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-faint)' }
  const inputStyle = {
    width: '100%', padding: '11px 14px 11px 38px', marginTop: 6,
    border: '1px solid var(--border-strong)', borderRadius: 10, fontSize: 14, outline: 'none'
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'radial-gradient(circle at 20% 20%, #2b2f77 0%, #14152b 55%, #0b0b16 100%)',
      padding: 16
    }}>
      <div style={{
        background: 'var(--surface)', borderRadius: 20, padding: 'clamp(24px, 8vw, 40px) clamp(20px, 7vw, 36px)',
        width: 380, maxWidth: '100%', boxShadow: '0 30px 80px rgba(0,0,0,0.45)', border: '1px solid rgba(255,255,255,0.06)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 30 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14, margin: '0 auto 16px',
            background: 'linear-gradient(135deg, var(--brand), #7c8cf8)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 8px 20px rgba(79,70,229,0.35)'
          }}>
            <Satellite size={24} color="#fff" strokeWidth={2} />
          </div>
          <h1 style={{ fontSize: 21, fontWeight: 800, color: 'var(--text)', letterSpacing: -0.4 }}>{businessName}</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 3 }}>Rekap Laporan Teknisi</p>
        </div>

        {error && <Alert type="error">{error}</Alert>}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <Label>Username</Label>
            <div style={inputWrap}>
              <User size={16} style={inputIcon} />
              <input
                type="text" value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                style={inputStyle}
                placeholder="Masukkan username"
                onFocus={e => { e.target.style.borderColor = 'var(--brand)'; e.target.style.boxShadow = '0 0 0 3px var(--brand-soft)' }}
                onBlur={e => { e.target.style.borderColor = 'var(--border-strong)'; e.target.style.boxShadow = 'none' }}
              />
            </div>
          </div>
          <div style={{ marginBottom: 26 }}>
            <Label>Password</Label>
            <div style={inputWrap}>
              <Lock size={16} style={inputIcon} />
              <input
                type="password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                style={inputStyle}
                placeholder="Masukkan password"
                onFocus={e => { e.target.style.borderColor = 'var(--brand)'; e.target.style.boxShadow = '0 0 0 3px var(--brand-soft)' }}
                onBlur={e => { e.target.style.borderColor = 'var(--border-strong)'; e.target.style.boxShadow = 'none' }}
              />
            </div>
          </div>
          <Button type="submit" loading={loading} style={{ width: '100%', padding: '12px' }}>
            {loading ? 'Memproses...' : 'Login'}
          </Button>
        </form>
      </div>
    </div>
  )
}
